import { alpha } from "@mui/material/styles";
import { PUBLIC_BRAND } from "../../ui/components/eventCard/publicEventCardStyles";

/** Page-only styles for PublicEventsPage */
export const publicEventsPageSx = {
  page: {
    minHeight: "100vh",
    background: `linear-gradient(165deg, ${PUBLIC_BRAND.cream} 0%, #fff 38%, ${alpha(PUBLIC_BRAND.orange, 0.06)} 100%)`,
  },
  header: {
    position: "sticky" as const,
    top: 0,
    zIndex: 1100,
    px: { xs: 2, md: 4 },
    py: 1.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid",
    borderColor: alpha(PUBLIC_BRAND.orange, 0.12),
    bgcolor: alpha("#fff", 0.88),
    backdropFilter: "blur(12px)",
  },
  joinBtn: {
    borderRadius: 2,
    textTransform: "none" as const,
    fontWeight: 700,
    px: 2.5,
    bgcolor: PUBLIC_BRAND.orange,
    boxShadow: `0 4px 14px ${alpha(PUBLIC_BRAND.orange, 0.4)}`,
    "&:hover": { bgcolor: PUBLIC_BRAND.orangeDark },
  },
  signInBtn: {
    borderRadius: 2,
    textTransform: "none" as const,
    fontWeight: 600,
    borderColor: alpha(PUBLIC_BRAND.orange, 0.5),
    color: PUBLIC_BRAND.orange,
  },
  hero: {
    position: "relative" as const,
    borderRadius: 4,
    overflow: "hidden",
    px: { xs: 2.5, sm: 3.5 },
    py: { xs: 3, sm: 4 },
    mb: 3,
    background: `linear-gradient(135deg, ${PUBLIC_BRAND.orange} 0%, ${PUBLIC_BRAND.orangeDark} 100%)`,
    color: "#fff",
    boxShadow: `0 16px 48px ${alpha(PUBLIC_BRAND.orange, 0.35)}`,
  },
  heroPattern: {
    position: "absolute" as const,
    right: -24,
    top: -24,
    width: 180,
    height: 180,
    borderRadius: "50%",
    bgcolor: alpha("#fff", 0.08),
  },
  searchCard: {
    p: { xs: 1.5, sm: 2 },
    mb: 2,
    borderRadius: 3,
    bgcolor: "#fff",
    border: "1px solid",
    borderColor: alpha(PUBLIC_BRAND.orange, 0.1),
    boxShadow: "0 8px 32px rgba(22, 28, 36, 0.06)",
  },
  searchInput: {
    borderRadius: 2.5,
    bgcolor: PUBLIC_BRAND.cream,
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${PUBLIC_BRAND.orange}`,
    },
  },
  filterSelect: {
    borderRadius: 2,
    bgcolor: PUBLIC_BRAND.cream,
    fontWeight: 700,
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: alpha(PUBLIC_BRAND.orange, 0.3) },
  },
  freeToggle: {
    px: 2,
    py: 1,
    borderRadius: 2,
    bgcolor: PUBLIC_BRAND.cream,
    border: "1px solid",
    borderColor: alpha(PUBLIC_BRAND.orange, 0.15),
  },
  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    px: 1.75,
    py: 0.75,
    mb: 2.5,
    borderRadius: 99,
    bgcolor: alpha(PUBLIC_BRAND.orange, 0.1),
    color: PUBLIC_BRAND.orangeDark,
    fontWeight: 700,
    fontSize: "0.875rem",
  },
  eventsGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
    gap: { xs: 2, md: 2.5 },
  },
  emptyState: {
    py: 8,
    px: 3,
    textAlign: "center" as const,
    borderRadius: 4,
    bgcolor: "#fff",
    border: "1px dashed",
    borderColor: alpha(PUBLIC_BRAND.orange, 0.25),
  },
};
